export default function debounce(item, callback, wait) {
    if (!item.data('debounce')) {
        item.data('debounce', _.debounce(callback => callback(), wait || 500));
    }
    let debouncer = item.data('debounce');
    debouncer(callback);
}
